import { render } from 'solid-js/web';
import { sheet } from '../state/sheet';
import { exportPng as coreExportPng } from '../core/exportPng';
import { SheetSVG } from './SheetSVG';
import { triggerDownload } from './download';
import { setPdfExporting, setPngExporting, pushToast } from './uiState';
import type { SheetState } from '../types';

function snapshot(): SheetState {
  return { slots: sheet.slots.map(s => ({ ...s })) };
}

export async function handleExportPng(): Promise<void> {
  setPngExporting(true);
  // Mount the offscreen container in document.body (visually hidden) — some
  // browsers require an attached element for full SVG layout when the tree is
  // serialized. We always remove it in `finally`.
  const container = document.createElement('div');
  container.style.cssText = 'position:absolute;left:-99999px;top:0;width:0;height:0;overflow:hidden;';
  document.body.appendChild(container);
  let dispose: (() => void) | undefined;
  try {
    dispose = render(() => <SheetSVG slots={sheet.slots} />, container);
    const svg = container.querySelector('svg') as SVGSVGElement | null;
    if (!svg) throw new Error('SheetSVG did not produce an <svg> element');
    const blob = await coreExportPng(svg);
    triggerDownload(blob, 'badges-sheet.png');
  } catch (err) {
    pushToast({ kind: 'error', text: `PNG: ${(err as Error).message}` });
    console.error(err);
  } finally {
    dispose?.();
    container.remove();
    setPngExporting(false);
  }
}

export async function handleExportPdf(): Promise<void> {
  setPdfExporting(true);
  try {
    // Lazy-load pdf-lib + exportPdf only on first click.
    const { exportPdf } = await import('../core/exportPdf');
    const blob = await exportPdf(snapshot());
    triggerDownload(blob, 'badges-sheet.pdf');
  } catch (err) {
    pushToast({ kind: 'error', text: `PDF: ${(err as Error).message}` });
    console.error(err);
  } finally {
    setPdfExporting(false);
  }
}
